import { createFileRoute, redirect } from "@tanstack/react-router";
import { CodingRulesClient } from "@/features/purchaseInvoices/CodingRulesClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Geleerde codering: what WLX learned from changes by hand on purchase invoices (docs/inkoopfacturen.md §7.8).
export const Route = createFileRoute("/_shell/purchase-invoices/coding-rules")({
  beforeLoad: ({ context }) => {
    const { session } = context;
    if (
      !session.roles.includes("admin") &&
      !hasModule(session, "purchase_invoices") &&
      !hasModule(session, "purchase_invoices_write")
    ) {
      throw redirect({ to: firstAllowedRoute(session) });
    }
  },
  component: CodingRulesScreen,
});

function CodingRulesScreen() {
  const { session } = Route.useRouteContext();
  const canWrite =
    session.roles.includes("admin") ||
    hasModule(session, "purchase_invoices_write");
  return (
    <div className="wl-page" data-screen-label="Back-office Coding Rules">
      <CodingRulesClient canWrite={canWrite} />
    </div>
  );
}
